module.exports = __webpack_public_path__ + "static/media/legoLand.1c3b0eb2.webp";